module.exports = __webpack_public_path__ + "img/14_45.e52c80ce.png";